import styled from 'styled-components';

import { DEFAULT_BACKGROUND_GRADIENT } from '../../../utils/colours';

export const Background = styled.div`
    position: fixed;
    z-index: -1;
    top: 0;
    width: 100%;
    height: 100vh;
    background: ${({ imageURL, gradient }) =>
        gradient ? gradient : imageURL ? `url(${imageURL}), ${DEFAULT_BACKGROUND_GRADIENT}` : DEFAULT_BACKGROUND_GRADIENT};
`;

Background.displayName = 'Background';

export const PageContainer = styled.main`
    max-width: 90%;
    min-height: 100vh;
    margin: auto;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: clamp(1rem, 4vh, 3rem);
    
    & > :first-child { // logo
        margin: 0 auto;
    }

    ${({ narrow }) => narrow && `width: 490px;`}
`;

PageContainer.displayName = 'PageContainer';
